import {Component} from '@angular/core';
import {Toast} from 'angular2-toaster';

@Component({
  selector: 'download-toaster',
  template: `<div>{{toast.row.name}} - {{toast.row.progress}} %</div>`
})
export class DownloadToasterComponent {
  public toast : Toast = null;

  constructor(){};
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/shared/download-toaster.component.ts